import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookMedical, faClose, faTrophy } from '@fortawesome/free-solid-svg-icons';
import 'react-slideshow-image/dist/styles.css';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import { useAuth } from '../../services/authentication/authentication.context';
import { Loader } from '../../components/utilities/loader';
import { BmsHeader } from '../../components/main-components/app.header';
import { AppFooter } from '../../components/main-components/footer';
import { buttonsData } from '../../helpers/mock-data';
import { SkewBox } from '../../components/page/skew';

import "../../styles/landing.css";
import "../../styles/home.css";
import { faFileLines } from '@fortawesome/free-regular-svg-icons';



export const LandingPage = () => {

    const { isLoading } = useAuth();

    const navigateTo = useNavigate();

    const [chooseOption, setOption] = useState(false);
    const [field, setField] = useState('');

   const getbg = (field) => {
    return buttonsData.find((val) => val.caption === field).background;
   }
    return (

        <div className='page-body'>
            {isLoading && <Loader />}
            <BmsHeader />
            <SkewBox
                title={"Notebook For Biomedical Sciences"}
                background={"/media/microscope.jpg"}
            />
            <div className={classNames('welcome-box', 'flx-c-r')}>
                <div className={classNames('welcome-section', 'flx-c-r')}>
                    <div className={classNames('welcome-text')}>
                        <div>
                            <div className='welcome-cap'>Welcome To</div>
                            <div className='welcome-sentence'>
                                Your go-to platform for medical studies and research.
                            </div>
                            <div className={classNames('welcome-sentence')}>
                                We help you go seemlessly through your medical studies providing study materials, HND tutorials and Video lessons.
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {chooseOption &&
                (
                    <div className='alert-bg' onClick={() => setOption(false)}>
                        <div className={classNames("alert-slider", { 'slide-up': chooseOption })}>
                            <div className='slider-top'>
                                <div className="slider-close-box">
                                    <FontAwesomeIcon icon={faClose} onClick={() => setOption(false)} className='close-box' />
                                </div>
                                <div 
                                    className='option-label'
                                    style={{
                                        backgroundImage: `url(${getbg(field)})`
                                    }}
                                >
                                    <div className="slider-caption">
                                        <span className="slider-caption-text">
                                            {field}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="alert-mid">
                                <div className='alert-caption'>
                                   
                        
                                </div>
                            </div>
                            <div className='alert-bottom'>
                                <div className='choice-buttons'>
                                    <button className='land-nav-btn'
                                        onClick={() => {
                                            navigateTo(`/lecture_notes`, { state: { field } })
                                        }}
                                    >
                                        {/* <img src='/icons/notes.svg' width={32} alt='' /> */}
                                        <FontAwesomeIcon 
                                            icon={faBookMedical} 
                                            className='opt-icon'
                                            color='#095655' 
                                        />
                                        <span style={{ color: "#095655" }}>Notes</span>
                                    </button>
                                    <button
                                        className='land-nav-btn'
                                        onClick={() => navigateTo(`/pastquestions`, { state: { field } })}
                                    >
                                        {/* <img src='/icons/evaluation.svg' width={32} alt='' /> */}
                                        <FontAwesomeIcon 
                                            icon={faFileLines} 
                                            className='opt-icon'
                                            color='#681703' 
                                        />
                                        <span style={{ color: "#681703" }}>HND past questions</span>
                                    </button>
                                    <button
                                        className='land-nav-btn'
                                        onClick={() => navigateTo(`/tutorials`, { state: { field } })}
                                    >
                                        {/* <img src='/icons/questions.svg' width={32} alt='' /> */}
                                        <FontAwesomeIcon 
                                            icon={faTrophy} 
                                            className='opt-icon'
                                            color='#4e0967' 
                                        />
                                        <span style={{ color: "#4e0967" }}>Tutorials</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }


            <div className='field-caption'>
                Lecture notes, Tutorials and Past Questions are available.
            </div>
            <div className="field-caption">
                Choose field of study
            </div>
            <div className="res-buttons">
                {buttonsData.map((data, k) => (
                    <div
                        className='res-unit'
                        style={{ backgroundImage: `url(${data.background})` }}
                        key={k}
                    >
                        <button
                            className={classNames("res-button")}
                            onClick={() => {
                                setOption(true);
                                setField(data.caption);
                            }}
                            key={k}
                        >
                            <span className="res-button-cap">{data.caption}</span>
                        </button>

                    </div>
                ))}
            </div>

            <AppFooter />
        </div>


    );
}